const getSlug = (slug, activeSite) => {
	const trimmedSlug = slug.trim()
	if (trimmedSlug === 'strona-glowna' || trimmedSlug === 'home' || trimmedSlug === 'startseite') {
		return activeSite === 'en' ? 'en' : activeSite === 'de' ? 'de' : '';
	}
	return activeSite === 'en' ? `en/${trimmedSlug}` : activeSite === 'de' ? `de/${trimmedSlug}` : trimmedSlug;
};

export default getSlug;
